import LxcError from "~/core/models/LxcError.class";
import dtwinService from "~/modules/dtwin/services/dtwin.service";

export function useBulkDeleteDtwins({
  organizationCode,
}: {
  organizationCode?: number;
}) {
  const isLoading = ref(false);
  const error: Ref<LxcError | undefined> = ref();

  async function bulkDeleteDtwins(dtwinUids: string[]) {
    isLoading.value = true;
    error.value = undefined;

    const response = await dtwinService.bulkDeleteOrganizationDtwins(
      organizationCode,
      dtwinUids,
    );

    if (LxcError.check(response)) {
      error.value = response;
    }

    isLoading.value = false;
  }

  return {
    isLoading,
    error,
    bulkDeleteDtwins,
  };
}
